import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { useGetCreditNoteHandler } from '../dataHandlers/getCreditNoteHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';
import CreditNoteForm from '../components/CreditNoteForm';
import { useResubmitCreditNoteHandler } from '../dataHandlers/resubmitCreditNoteHandler';
import { usePermissions } from '../../../hooks/usePermissions';
import { UPDATE_PURCHASE_CREDIT_NOTE, UPDATE_SALE_CREDIT_NOTE } from '../../../constants/eInvoicePermissions';
import { useActionDeniedSnackbar } from '../../../hooks/useActionDeniedSnackbar';

export default function ResubmitCreditNotePage({ isPurchase }) {
  useDocumentTitle('Resubmit Credit Note');
  const navigate = useNavigate();
  const { document_id } = useParams();
  const { loading, hasEInvoicePermission } = usePermissions();
  const showActionDeniedSnackbar = useActionDeniedSnackbar();
  const { creditNote, isLoading } = useGetCreditNoteHandler(document_id, isPurchase);

  useEffect(() => {
    if (loading) {
      return;
    }
    const updatePermission = isPurchase ? UPDATE_PURCHASE_CREDIT_NOTE : UPDATE_SALE_CREDIT_NOTE;
    if (!hasEInvoicePermission(updatePermission)) {
      showActionDeniedSnackbar();
      navigate(isPurchase ? '/purchases/documents?tab=credit-notes' : '/sales/documents?tab=credit-notes', {
        replace: true,
      });
    }
  }, [isPurchase, loading, hasEInvoicePermission, showActionDeniedSnackbar, navigate]);

  const onClickBackButton = () => {
    return navigate(isPurchase ? '/purchases/documents?tab=credit-notes' : '/sales/documents?tab=credit-notes');
  };

  const { onSubmit, error } = useResubmitCreditNoteHandler({
    onSuccess: onClickBackButton,
    isPurchase,
  });

  const onResubmit = async (data) => {
    const payload = {
      ...data,
      status: 'active',
    };
    await onSubmit(payload, document_id);
  };

  if (isLoading || !creditNote) {
    return <DocumentSkeletonForm />;
  }

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <CreditNoteForm
        onSubmit={onResubmit}
        onCancel={onClickBackButton}
        initialData={creditNote}
        isPurchase={isPurchase}
        apiErrors={error ?? {}}
        isResubmit={true}
      />
    </Stack>
  );
}
